import React, { useState } from "react";
import img1 from '../assets/photos/img1 (1).jpeg';
import img2 from '../assets/photos/img1 (2).jpeg';
import img3 from '../assets/photos/img1 (3).jpeg';
import img4 from '../assets/photos/img1 (4).jpeg';
import img5 from '../assets/photos/img1 (5).jpeg';
import img6 from '../assets/photos/img1 (6).jpeg';
import img7 from '../assets/photos/img1 (7).jpeg';
import img8 from '../assets/photos/img1 (8).jpeg';
import img9 from '../assets/photos/img1 (9).jpeg';
import img10 from '../assets/photos/img1 (10).jpeg';
import img11 from '../assets/photos/img1 (11).jpeg';
import img12 from '../assets/photos/img1 (12).jpeg';
import img13 from '../assets/photos/img1 (13).jpeg';
import img14 from '../assets/photos/img1 (14).jpeg';
import img15 from '../assets/photos/img1 (15).jpeg';
import img16 from '../assets/photos/img1 (16).jpeg';
import img17 from '../assets/photos/img1 (17).jpeg';
import img18 from '../assets/photos/img1 (18).jpeg';
import img19 from '../assets/photos/img1 (19).jpeg';
import img20 from '../assets/photos/img1 (20).jpeg';
import img21 from '../assets/photos/img1 (21).jpeg';
import img22 from '../assets/photos/img1 (22).jpeg';
import img23 from '../assets/photos/img1 (23).jpeg';
import img24 from '../assets/photos/img1 (24).jpeg';
import img25 from '../assets/photos/img1 (25).jpeg';
import img26 from '../assets/photos/img1 (26).jpeg';
import img27 from '../assets/photos/img1 (27).jpeg';
import img28 from '../assets/photos/img1 (28).jpeg';
import img29 from '../assets/photos/img1 (29).jpeg';
import img30 from '../assets/photos/img1 (30).jpeg';
import img31 from '../assets/photos/img1 (31).jpeg';
import img32 from '../assets/photos/img1 (32).jpeg';
import img33 from '../assets/photos/img1 (33).jpeg';
import img34 from '../assets/photos/img1 (34).jpeg';
import img35 from '../assets/photos/img1 (35).jpeg';
import img36 from '../assets/photos/img1 (36).jpeg';
import img37 from '../assets/photos/img1 (37).jpeg';
import img38 from '../assets/photos/img1 (38).jpeg';
import img39 from '../assets/photos/img1 (39).jpeg';
import img40 from '../assets/photos/img1 (40).jpeg';
import img41 from '../assets/photos/img1 (41).jpeg';
import img42 from '../assets/photos/img1 (42).jpeg';
import img43 from '../assets/photos/img1 (43).jpeg';
import img44 from '../assets/photos/img1 (44).jpeg';
import img45 from '../assets/photos/img1 (45).jpeg';
import img46 from '../assets/photos/img1 (46).jpeg';
import img47 from '../assets/photos/img1 (47).jpeg';
import img48 from '../assets/photos/img1 (48).jpeg';
import img49 from '../assets/photos/img1 (49).jpeg';
import img50 from '../assets/photos/img1 (50).jpeg';
// Project folder images
import proj1 from '../assets/project/imgnew (1).jpeg';
import proj2 from '../assets/project/imgnew (2).jpeg';
import proj3 from '../assets/project/imgnew (3).jpeg';
import proj4 from '../assets/project/imgnew (4).jpeg';
import proj5 from '../assets/project/imgnew (5).jpeg';
import proj6 from '../assets/project/imgnew (6).jpeg';
import proj7 from '../assets/project/imgnew (7).jpeg';
import proj8 from '../assets/project/imgnew (8).jpeg';
import proj9 from '../assets/project/imgnew (9).jpeg';
import proj10 from '../assets/project/imgnew (10).jpeg';
import proj11 from '../assets/project/imgnew (11).jpeg';
import proj12 from '../assets/project/imgnew (12).jpeg';
import proj13 from '../assets/project/imgnew (13).jpeg';
import proj14 from '../assets/project/imgnew (14).jpeg';
import proj15 from '../assets/project/imgnew (15).jpeg';
import proj16 from '../assets/project/imgnew (16).jpeg';

const Impact = () => {
  const [showAllPhotos, setShowAllPhotos] = useState(false);
  const [showAllProjects, setShowAllProjects] = useState(false);
  
  const photosOnly = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
    img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
    img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
    img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
    img41, img42, img43, img44, img45, img46, img47, img48, img49, img50
  ];
  
  const allPhotos = [
    // Photos folder images (50 photos)
    ...photosOnly,
    // Project folder images (16 photos)
    proj1, proj2, proj3, proj4, proj5, proj6, proj7, proj8, proj9, proj10,
    proj11, proj12, proj13, proj14, proj15, proj16
  ];
  
  const displayedPhotos = showAllPhotos ? photosOnly : [
    // Show only 10 photos initially for Work in Action section
    img4, img5, img6, img7, img8, img9, img10, img11, img12, img13
  ];
  
  const projectPhotos = [proj1, proj2, proj3, proj4, proj5, proj6, proj7, proj8, proj9, proj10, proj11, proj12, proj13, proj14, proj15, proj16];
  
  const displayedProjectPhotos = showAllProjects ? projectPhotos : [
    // Show only 8 photos initially for Projects section
    proj1, proj2, proj3, proj4, proj5, proj6, proj7, proj8
  ];
  const stories = [
    {
      id: 1,
      title: "Ramesh's Water Conservation Success",
      category: "Water Conservation",
      image: img1,
      quote:
        "Thanks to Darim's water conservation techniques, I've been able to save over 50% of water while increasing my farm's productivity. The rainwater harvesting system changed everything.",
      author: "Ramesh Singh",
      location: "Tehri Garhwal",
    },
    {
      id: 2,
      title: "Empowering Women Through Skills",
      category: "Livelihood",
      image: img3,
      quote:
        "The tailoring course gave me the confidence and skills to start my own boutique. Now I support my family independently.",
      author: "Sunita Devi",
      location: "Uttarkashi",
    },
    {
      id: 3,
      title: "Clean Water for Village Kot",
      category: "Water & Sanitation",
      image: img2,
      quote:
        "We used to walk kilometers for water. Now, thanks to the new pipeline, we have clean water right at our doorstep.",
      author: "Village Pradhan",
      location: "Rudraprayag",
    },
  ];

  const metrics = [
    { number: "50,000+", label: "Lives Impacted", icon: "👥" },
    { number: "15,000+", label: "Children Educated", icon: "🎓" },
    { number: "25,000+", label: "Patients Treated", icon: "🏥" },
    { number: "1,000+", label: "Farmers Trained", icon: "🌾" },
    { number: "500+", label: "Women Entrepreneurs", icon: "👩‍💼" },
    { number: "100+", label: "Villages Served", icon: "🏘️" },
  ];

  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Hero Section */}
      <section className="relative py-16 md:py-20 bg-gradient-to-br from-primary-dark/10 to-primary/20 text-center rounded-b-3xl shadow-lg">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto animate-fade-in">
            <span className="inline-block text-accent font-semibold text-sm uppercase tracking-widest mb-4">
              Our Impact
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-heading">
              Real Stories, Real Change
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Measuring our success not just in numbers, but in the transformed
              lives and empowered communities across Uttarakhand.
            </p>
          </div>
        </div>
      </section>

      {/* Key Metrics Grid */}
      <section className="py-12 md:py-16 bg-white/90 backdrop-blur-sm shadow-lg rounded-2xl mx-4 md:mx-8 lg:mx-auto lg:max-w-7xl px-4 -mt-8 relative z-10">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 font-heading">
              Impact at a Glance
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {metrics.map((metric, index) => (
              <div
                key={index}
                className="p-6 bg-gray-50 rounded-2xl text-center hover:bg-primary hover:text-white transition-all duration-300 group cursor-default"
              >
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">
                  {metric.icon}
                </div>
                <div className="text-2xl font-bold text-primary group-hover:text-white mb-1 font-heading">
                  {metric.number}
                </div>
                <div className="text-sm text-gray-600 group-hover:text-white/90 font-medium">
                  {metric.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-gray-50 to-white mt-8">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-accent font-bold uppercase tracking-widest text-sm">
              Voices from the Ground
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 font-heading">
              Success Stories
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stories.map((story) => (
              <div
                key={story.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full"
              >
                <div className="h-56 relative overflow-hidden">
                  <img 
                    src={story.image} 
                    alt={story.title}
                    className={`w-full h-full object-cover ${
                      story.title.includes("Ramesh") ? "rotate-180" : ""
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>
                <div className="p-8 flex-1 flex flex-col">
                  <div className="mb-4">
                    <span className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider rounded-full">
                      {story.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 font-heading">
                    {story.title}
                  </h3>
                  <blockquote className="text-gray-600 italic mb-6 flex-1">
                    "{story.quote}"
                  </blockquote>
                  <div className="flex items-center mt-auto pt-6 border-t border-gray-100">
                    <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-3">
                      👤
                    </div>
                    <div>
                      <div className="font-bold text-gray-800">
                        {story.author}
                      </div>
                      <div className="text-sm text-gray-500">
                        {story.location}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impact Gallery */}
      <section className="py-12 md:py-16 bg-white/90 backdrop-blur-sm shadow-lg rounded-2xl mx-4 md:mx-8 lg:mx-auto lg:max-w-7xl px-4 mt-8">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-accent font-bold uppercase tracking-widest text-sm">
              Visual Impact
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 font-heading">
              Our Work in Action
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full mt-4"></div>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {displayedPhotos.map((image, index) => (
              <div
                key={index}
                className="aspect-square rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group relative"
              >
                <img 
                  src={image} 
                  alt={`Impact photo ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4">
                    <span className="text-white font-bold text-sm bg-black/50 px-2 py-1 rounded">
                      View Photo
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            {!showAllPhotos ? (
              <button 
                onClick={() => setShowAllPhotos(true)}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary text-white rounded-full text-lg font-bold shadow-lg hover:bg-primary-dark hover:shadow-xl transition-all duration-300"
              >
                <span>Load All {photosOnly.length} Photos</span>
                <span></span>
              </button>
            ) : (
              <div className="space-y-4">
                <p className="text-gray-600 font-medium">
                  Showing all {photosOnly.length} photos
                </p>
                <button 
                  onClick={() => setShowAllPhotos(false)}
                  className="inline-flex items-center justify-center gap-2 px-6 py-2 bg-gray-200 text-gray-700 rounded-full text-sm font-medium hover:bg-gray-300 transition-all duration-300"
                >
                  <span>Show Less</span>
                  <span>↑</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Projects Gallery Section */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-white to-gray-50 mt-8">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-accent font-bold uppercase tracking-widest text-sm">
              Project Showcase
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 font-heading">
              Our Projects in Action
            </h2>
            <div className="w-24 h-1 bg-accent mx-auto rounded-full mt-4"></div>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Explore our dedicated project implementations and see the tangible impact of our work across Uttarakhand.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {displayedProjectPhotos.map((project, index) => (
              <div
                key={index}
                className="aspect-square rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group relative"
              >
                <img 
                  src={project} 
                  alt={`Project photo ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-accent/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4">
                    <span className="text-white font-bold text-sm bg-accent/80 px-2 py-1 rounded">
                      Project {index + 1}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            {!showAllProjects ? (
              <button 
                onClick={() => setShowAllProjects(true)}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-accent text-white rounded-full text-lg font-bold shadow-lg hover:bg-accent-dark hover:shadow-xl transition-all duration-300"
              >
                <span>View All Projects ({projectPhotos.length})</span>
                <span>🏗️</span>
              </button>
            ) : (
              <div className="space-y-4">
                <p className="text-gray-600 font-medium">
                  Showing all {projectPhotos.length} projects
                </p>
                <button 
                  onClick={() => setShowAllProjects(false)}
                  className="inline-flex items-center justify-center gap-2 px-6 py-2 bg-gray-200 text-gray-700 rounded-full text-sm font-medium hover:bg-gray-300 transition-all duration-300"
                >
                  <span>Show Less</span>
                  <span>↑</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </section>


      {/* Annual Reports CTA */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-primary to-primary-dark text-white mt-12 rounded-t-3xl shadow-xl">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6 font-heading">
            Transparency & Accountability
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            We believe in complete transparency. View our annual reports and
            financial statements to see how your contributions are utilized.
          </p>
          <button className="inline-flex items-center justify-center px-8 py-4 bg-white text-primary rounded-full text-lg font-bold shadow-lg hover:bg-gray-100 transition-all duration-300">
            Download Annual Report 2024 📄
          </button>
        </div>
      </section>
    </div>
  );
};

export default Impact;
